// Phase 82h — Map backend match list → home Live Matches card shape
// Used by AthleteHomePage LiveMatches section.

const _player = (name, seed) => ({
  name: name || "Đối thủ",
  avatar: "/avatar-fallback.svg",
});

function teamPlayers(team) {
  if (!team) return [_player("Đội")];
  const label = team.name || team.label || "Đội";
  const parts = label.split(/\s*\/\s*/).filter(Boolean);
  return parts.map((n) => _player(n, n));
}

function pickCurrentScore(m) {
  const sets = m.sets || [];
  if (sets.length === 0) return { scoreA: 0, scoreB: 0, game: 1, gameScore: "0 - 0" };
  const idx = (m.current_set || 1) - 1;
  const cur = sets[idx] || sets[sets.length - 1];
  // Sets won so far
  const setsA = sets.filter(
    (s) => (s.score_a || 0) >= 11 && (s.score_a || 0) - (s.score_b || 0) >= 2
  ).length;
  const setsB = sets.filter(
    (s) => (s.score_b || 0) >= 11 && (s.score_b || 0) - (s.score_a || 0) >= 2
  ).length;
  return {
    scoreA: cur?.score_a || 0,
    scoreB: cur?.score_b || 0,
    game: m.current_set || 1,
    gameScore: `${setsA} - ${setsB}`,
  };
}

export function mapHomeMatch(m) {
  if (!m) return null;
  const score = pickCurrentScore(m);
  return {
    id: m.id,
    eventName: m.event_name || "Trận đấu",
    round: m.round_name || "",
    court: m.court_name || "—",
    teamA: teamPlayers(m.team_a),
    teamB: teamPlayers(m.team_b),
    scoreA: score.scoreA,
    scoreB: score.scoreB,
    game: score.game,
    gameScore: score.gameScore,
    // Phase 84.M.29 — Surface backend viewer_count (sticky per match in DB,
    // bumped via livestream session pings). Falls back to 0 when missing.
    viewers: m.viewer_count || 0,
    bestOf: m.best_of || null,
    tournamentSlug: m.tournament_slug,
    tournamentId: m.tournament_id,
  };
}

export function mapHomeMatches(list) {
  if (!Array.isArray(list)) return [];
  return list.map(mapHomeMatch).filter(Boolean);
}

// ─── Phase 82i — Athlete Matches Page (live/upcoming/completed cards) ───
function timeFromIso(iso) {
  if (!iso) return "TBD";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "TBD";
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

function minutesUntil(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  return Math.round((d.getTime() - Date.now()) / (1000 * 60));
}

function relativeFinish(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const today = new Date();
  const sameDay = d.toDateString() === today.toDateString();
  const t = timeFromIso(iso);
  if (sameDay) return `Hôm nay • ${t}`;
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  if (d.toDateString() === yesterday.toDateString()) return `Hôm qua • ${t}`;
  return `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")} • ${t}`;
}

function winnerSideFromSets(sets) {
  if (!Array.isArray(sets) || sets.length === 0) return null;
  const setsA = sets.filter(
    (s) => (s.score_a || 0) >= 11 && (s.score_a || 0) - (s.score_b || 0) >= 2
  ).length;
  const setsB = sets.filter(
    (s) => (s.score_b || 0) >= 11 && (s.score_b || 0) - (s.score_a || 0) >= 2
  ).length;
  return setsA > setsB ? "A" : setsB > setsA ? "B" : null;
}

export function mapMatchesPageLive(list) {
  if (!Array.isArray(list)) return [];
  return list
    .map((m) => {
      const sets = m.sets || [];
      const idx = (m.current_set || 1) - 1;
      const cur = sets[idx] || sets[sets.length - 1];
      const setsA = sets.filter(
        (s) => (s.score_a || 0) >= 11 && (s.score_a || 0) - (s.score_b || 0) >= 2
      ).length;
      const setsB = sets.filter(
        (s) => (s.score_b || 0) >= 11 && (s.score_b || 0) - (s.score_a || 0) >= 2
      ).length;
      const scoreA = cur?.score_a || 0;
      const scoreB = cur?.score_b || 0;
      return {
        id: m.id,
        eventName: m.event_name || "Trận đấu",
        bracketCode: m.match_code || (m.round_name || "M"),
        court: m.court_name || "—",
        teamA: teamPlayers(m.team_a),
        teamB: teamPlayers(m.team_b),
        scoreA,
        scoreB,
        serving: "A",
        gameNumber: m.current_set || 1,
        setsA,
        setsB,
        duration: m.duration || "",
        viewers: 0,
        tournamentId: m.tournament_id,
        tournamentName: m.tournament_name || "",
        isMatchPoint:
          (scoreA >= 10 && scoreA - scoreB >= 1) ||
          (scoreB >= 10 && scoreB - scoreA >= 1),
        eventCategory: m.round_name || "Vòng đấu",
      };
    })
    .filter(Boolean);
}

export function mapMatchesPageUpcoming(list) {
  if (!Array.isArray(list)) return [];
  return list
    .map((m) => ({
      id: m.id,
      eventName: m.event_name || "Trận đấu",
      bracketCode: m.match_code || (m.round_name || "M"),
      court: m.court_name || "—",
      teamA: teamPlayers(m.team_a),
      teamB: teamPlayers(m.team_b),
      startTime: timeFromIso(m.scheduled_at),
      minutesUntil: minutesUntil(m.scheduled_at),
      tournamentName: m.tournament_name || "",
    }))
    .filter(Boolean);
}

export function mapMatchesPageCompleted(list) {
  if (!Array.isArray(list)) return [];
  return list
    .map((m) => {
      const sets = m.sets || [];
      const totalA = sets.reduce((s, x) => s + (x.score_a || 0), 0);
      const totalB = sets.reduce((s, x) => s + (x.score_b || 0), 0);
      const winner = winnerSideFromSets(sets);
      return {
        id: m.id,
        eventName: m.event_name || "Trận đấu",
        round: m.round_name || "Vòng đấu",
        court: m.court_name || "—",
        teamA: teamPlayers(m.team_a),
        teamB: teamPlayers(m.team_b),
        scoreA: totalA,
        scoreB: totalB,
        winner,
        finishedAt: relativeFinish(m.completed_at || m.scheduled_at),
        hasReplay: !!(m.replay_url || m.video_url),
      };
    })
    .filter(Boolean);
}
